import { ReportingConfig } from '@opengov/app-config-reporting';
import { Map } from 'immutable';
import { ILaunchDarklyParams, LDClient, ldInitialize, sessionToLDUser } from '@opengov/launchdarkly';
import { createZustandStoreAndContext } from '@opengov/react-state-management';

import { FeatureFlagStatus } from './launchDarklyState';

export const launchDarklyEnvironmentKey = ReportingConfig.LAUNCH_DARKLY_ENV_KEY;
const isLaunchDarklyAvailable = !!launchDarklyEnvironmentKey;

const initializeLd = ldInitialize(isLaunchDarklyAvailable, launchDarklyEnvironmentKey, () => {});

const createClient = async (params: ILaunchDarklyParams): Promise<LDClient> => {
  return initializeLd(params).then(async (initializedClient) => {
    return initializedClient.identify(sessionToLDUser(params)).then(() => initializedClient);
  });
};

export interface IFeatureFlagStore {
  featureFlags: Map<string, any>;
  featureFlagStatus: FeatureFlagStatus;
  getFlags(params: ILaunchDarklyParams): Promise<any>;
}

const launchDarklyInitialState = {
  featureFlags: Map<string, any>(),
  featureFlagStatus: FeatureFlagStatus.Loading
};

export const [useFeatureFlagStore, featureFlagContext, cloneFeatureFlagStore] =
  createZustandStoreAndContext<IFeatureFlagStore>((set, get) => ({
    ...launchDarklyInitialState,
    getFlags: async (params: ILaunchDarklyParams) => {
      return createClient(params).then(async (client) => {
        set({ featureFlags: Map(client.allFlags()) });
        set({ featureFlagStatus: FeatureFlagStatus.Current });
      });
    }
  }));
